import isoCodes from "../../data/iso-codes.json";

const state = () => ({
  basicPage: null,
  content: null,
  jurisdictions: null,
  isoCodes,
  filters: null,
  requirementsTree: null,
  watchlist: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  appendData(state, data) {
    state[data.label].push(data.data);
  },
  updateData(state, data) {
    // const parsedObj = JSON.parse(JSON.stringify(state[data.label]));
    // console.log(parsedObj);

    // for (let obj in parsedObj) {
    //   for (let obj2 in obj) {
    //     console.log(obj2.requirements);
    //   }

    // }

    // parsedObj.forEach((item) => {
    //   console.log("item is ", item)
    //   item.children.forEach((child, key) => {
    //     if (child.requirements)
    //       console.log(child, key)
    //   })
    // })
    state[data.label] = data.data;
  },
  insertRequirementData(state, data) {
    if (!data.countryState) {
      state[data.label]
        .find((e) => e.tid === data.jurisdictionParent)
        .children.find((e) => e.tid === data.pid)
        .licenses.find((e) => e.tid === data.id).requirements = data.data;
    } else {
      state[data.label]
        .find((e) => e.tid === data.jurisdictionParent)
        .children.find((e) => e.tid === data.pid)
        .children.find((e) => e.tid === data.countryState)
        .licenses.find((e) => e.tid === data.id).requirements = data.data;
    }
  },
  // concatData(state, data) {
  //   console.log("concat", data.data);
  //   data.data.map((el) => {
  //     state[data.label].push(el);
  //   });
  // },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, `${this.$config.jasonApiURL}${url}`);
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },

  async getRequirementByJurisdiction({ commit, state }, id) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}/requirements/${id}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
